function Contact() {
  return (
    <section id="contact" className="bg-canvas-alt py-[88px]">
      <div className="wrap">
        <div className="flex flex-wrap items-center justify-between gap-8 rounded-[20px] bg-[linear-gradient(135deg,#121d42,#1b2a5c)] p-14 max-[720px]:px-6 max-[720px]:py-9">
          <div>
            <p className="eyebrow">Get in Touch</p>
            <h2 className="text-white">Have a project in mind?</h2>
            <p className="section-lead text-white/75">
              Tell us about your website, app, or idea — we&apos;ll get back to you.
            </p>
          </div>
          <div className="flex min-w-[260px] flex-col gap-[14px]">
            <a className="btn-primary text-center" href="mailto:venus.solutions95@gmail.com">
              venus.solutions95@gmail.com
            </a>
            <a
              className="btn border-white/30 bg-white/[0.06] text-center text-white hover:border-teal-light hover:text-teal-light"
              href="https://invyntra.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              invyntra.in
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
